import { render, staticRenderFns } from "./InputStock.vue?vue&type=template&id=59767d23&scoped=true"
import script from "./InputStock.vue?vue&type=script&lang=js"
export * from "./InputStock.vue?vue&type=script&lang=js"
import style0 from "./InputStock.vue?vue&type=style&index=0&id=59767d23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59767d23",
  null
  
)

export default component.exports